export const paths = {
  root: '/',
  leads: '/leads',
  leadsList: '/leads-list',
  leadsCreate: '/leads/create',

  //tasks
  tasks: {
    root: '/tasks',
    kanban: '/tasks/kanban'
  },

  //logs (audit)
  logs: '/logs',

  //opportunities
  opportunities: '/opportunities',
  opportunitiesList: '/opportunities-list',
  opportunitiesCreate: '/opportunities/create',

  //opportunities details
  opportunitiesDetails: {
    root: (opportunityId?: string, id?: string) =>
      `/opportunities/${opportunityId}/details/${id}`,
    edit: (opportunityId?: string, id?: string) =>
      `/opportunities/${opportunityId}/details/${id}/edit`,
    contracts: (opportunityId?: string, id?: string) =>
      `/opportunities/${opportunityId}/details/${id}/contracts`,
    tasks: (opportunityId?: string, id?: string) =>
      `/opportunities/${opportunityId}/details/${id}/tasks`,
    documents: (opportunityId?: string, id?: string) =>
      `/opportunities/${opportunityId}/details/${id}/documents`,
    contacts: (opportunityId?: string, id?: string) =>
      `/opportunities/${opportunityId}/details/${id}/contacts`,
    products: (opportunityId?: string, id?: string) =>
      `/opportunities/${opportunityId}/details/${id}/products`,
    offers: (opportunityId?: string, id?: string) =>
      `/opportunities/${opportunityId}/details/${id}/offers`,
    paymentAccounts: (opportunityId?: string, id?: string) =>
      `/opportunities/${opportunityId}/details/${id}/payment-accounts`
  },

  //clients
  clients: '/clients',

  //clients details
  clientsDetails: {
    root: (id?: string) => `/clients/${id}`,
    contacts: (id?: string) => `/clients/${id}/contacts`,
    leads: (id?: string) => `/clients/${id}/leads`,
    contracts: (id?: string) => `/clients/${id}/contracts`,
    opportunities: (id?: string) => `/clients/${id}/opportunities`,
    tasks: (id?: string) => `/clients/${id}/tasks`,
    logs: (id?: string) => `/clients/${id}/logs`
  },

  //leads details
  leadsDetails: {
    root: (id?: string) => `/leads/${id}`,
    edit: (id?: string) => `/leads/${id}/edit`,
    opportunities: (id?: string) => `/leads/${id}/opportunities`,
    contracts: (id?: string) => `/leads/${id}/contracts`,
    tasks: (id?: string) => `/leads/${id}/tasks`,
    documents: (id?: string) => `/leads/${id}/documents`,
    contacts: (id?: string) => `/leads/${id}/contacts`,
    campaigns: (id?: string) => `/leads/${id}/campaigns`
  },
  admin: {
    nomenclatures: {
      root: '/nomenclatures',

      general: {
        root: '/nomenclatures/general',
        industries: '/nomenclatures/general/industries',
        industry: (id: string) => `/nomenclatures/general/industries/${id}`,
        reasons: '/nomenclatures/general/reasons',
        currencies: '/nomenclatures/general/currencies',
        documents: '/nomenclatures/general/documents',
        emailTemplates: '/nomenclatures/general/email-templates',
        mailboxes: '/nomenclatures/general/mailboxes',
        mailboxesAuth: '/nomenclatures/general/mailboxes/auth',
        tags: '/nomenclatures/general/tags',
        countries: '/nomenclatures/general/countries',
        sizes: '/nomenclatures/general/sizes',
        seniorPositions: '/nomenclatures/general/senior-positions',
        seniorPosition: (id: string) =>
          `/nomenclatures/general/senior-positions/${id}`,
        customFields: '/nomenclatures/general/custom-fields'
      },

      leads: {
        root: '/nomenclatures/leads',
        statuses: '/nomenclatures/leads/statuses',
        types: '/nomenclatures/leads/types',
        type: (id: string) => `/nomenclatures/leads/types/${id}`,
        sources: '/nomenclatures/leads/sources'
      },

      opportunities: {
        root: '/nomenclatures/opportunities',
        pipelines: '/nomenclatures/opportunities/pipelines',
        pipeline: (id: string) =>
          `/nomenclatures/opportunities/pipelines/${id}`,
        statuses: '/nomenclatures/opportunities/statuses'
      },

      tasks: {
        root: '/nomenclatures/tasks',
        system: '/nomenclatures/tasks/system',
        custom: '/nomenclatures/tasks/custom',
        templates: '/nomenclatures/tasks/templates',
        statuses: '/nomenclatures/tasks/statuses'
      },
      products: {
        root: '/nomenclatures/products',
        categories: '/nomenclatures/products/categories',
        unitMeasure: '/nomenclatures/products/unit-measure'
      }
    },

    integrations: {
      root: '/integrations'
    }
  },
  reports: {
    generic: (id: string) => `/report/generic/${id}`,
    dashboard: '/report/dashboard'
  },
  leadImport: {
    root: '/leads/import',
    item: (id: string, step: string) => `/leads/import/${id}/${step}`,
    add: '/leads/import/add',
    first: '/leads/import/add/first',
    confirmImport: '/leads/import/add/confirm-import',
    confirmField: '/leads/import/add/confirm-field',
    checkDuplicates: '/leads/import/add/check-duplicates',
    startImport: '/leads/import/add/start-import'
  },
  reportManagement: {
    root: '/report-management',
    item: (id: string) => `/report-management/${id}`
  }
}
